"use strict"

angular
.module("ATMGCheckout")
.controller('CustomerNotesController', CustomerNotes)

CustomerNotes.$inject = ['Checkout', "Cart", '$scope', '$timeout']

function CustomerNotes(Checkout, Cart, $scope, $timeout) {
  
  this.submitNote = function(line_item, note) {
    return Cart.setCustomerNote(line_item.line_id, note)
    .then(function(response) {
      if (response.data.return_status === 'S') {
        $scope.$emit('modal.close')
        $timeout(function() {
          $scope.$emit('modal.open', {data: {message: 'Note added, thanks!'}, template: 'success', title: 'Note saved'})
        }, 100)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/ATMGCheckout/controllers/CustomerNotesController.js